import React from 'react';
type TopoLinesProps = {
  className?: string;
};

/**
 * Curvas de nivel (cuaderno de campo) — el motivo de portada de los tomos
 * DPS43. Hereda el color via `currentColor`.
 */
export function TopoLines({
  className
}: TopoLinesProps) {
  return <svg viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true" className={className} data-id="element-289" data-mp="2tuiy8bzilqan">
      <path d="M120 14c58 0 104 40 102 100-2 62-50 110-110 108C54 220 16 176 20 118 24 60 64 14 120 14z" data-id="element-290" data-mp="3mi52znkhb0z3" />
      <path d="M121 40c42 0 76 30 74 74-2 46-38 80-84 78-42-2-70-34-66-78 4-42 34-74 76-74z" data-id="element-291" data-mp="3qguq47vbjwvx" />
      <path d="M122 66c28 0 50 20 48 50-2 30-26 52-56 50-28-2-46-22-42-50 2-28 22-50 50-50z" data-id="element-292" data-mp="3cixtjbgv7qh9" />
      <path d="M123 92c14 0 24 10 23 24-1 15-12 25-27 24-13-1-21-11-20-24 1-14 11-24 24-24z" data-id="element-293" data-mp="3hgfr65pfmj9y" />
      <path d="M128 112l-2 6 6-2" strokeWidth={2.5} data-id="element-294" data-mp="212fwb95g1jtk" />
    </svg>;
}